'use strict';

exports.__esModule = true;
exports.getValueByIdentifier = getValueByIdentifier;
exports.getMetaByIdentifier = getMetaByIdentifier;

var _isEmpty = require('../utils/is-empty');

var _validateTagStructure = require('../utils/validate-tag-structure');

var _TagSchemas = require('../../types/TagSchemas');

function getValueByIdentifier(tags, identifier) {
  var result = findTag(tags, identifier);
  return result ? getValueFromTag(result, identifier) : result;
}

function getMetaByIdentifier(tags, identifier) {
  var result = findTag(tags, identifier);
  return (result ? result.meta : null) || {};
}

function findTag(tags, identifier) {
  if (!tags || !identifier) {
    return null;
  }
  var tag = getTagByIdentifier(tags, identifier);
  if ((0, _isEmpty.isEmpty)(tag)) {
    return undefined;
  }
  return tag;
}

function getTagByIdentifier(tags, identifier) {
  var tagSchema = _TagSchemas.TAG_SCHEMAS[identifier];
  if ((0, _isEmpty.isEmpty)(tagSchema) || (0, _isEmpty.isEmpty)(tags)) {
    return {};
  }

  return tags.slice().reverse().find(function (tag) {
    return (0, _validateTagStructure.validateTagStructure)(tag, tagSchema);
  });
}

function getValueFromTag(tag, identifier) {
  var tagSchema = identifier && _TagSchemas.TAG_SCHEMAS[identifier];

  if ((0, _isEmpty.isEmpty)(tag) || (0, _isEmpty.isEmpty)(tagSchema)) {
    return '';
  }

  return tagSchema.getValue(tag);
}